import { render, staticRenderFns } from "./ActeListeBeta.vue?vue&type=template&id=4cc2a459&"
import script from "./ActeListeBeta.vue?vue&type=script&lang=js&"
export * from "./ActeListeBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports